<template>
  <div class="m-5 md:m-15">
    <h3 class="my-15 w-full">Check-list des moyens mis en place</h3>

    <!-- BEGIN Differents tab for preconisation types -->
    <div class="text-xl text-gray-600 font-medium mb-15 flex justify-center space-x-10" >
      <div class="cursor-pointer w-max-content w-max" @click="displayTab('accessibilite')" :class="{'text-indigo-600' :tab_display == 'accessibilite'}" >Accessibilite</div>
      <div class="cursor-pointer w-max-content w-max" @click="displayTab('postedetravail')" :class="{'text-indigo-600' :tab_display == 'postedetravail'}" >Poste de travail</div>
      <div class="cursor-pointer w-max-content w-max" @click="displayTab('autonomie')" :class="{'text-indigo-600' :tab_display == 'autonomie'}" >Autonomie</div>
    </div>
    <!-- END Differents tab for preconisation types -->


    <div class="border-2 border-gray-600 border-opacity-50 border-dashed rounded mb-15 mx-15 py-8 ">
      <div class="text-md text-indigo-600 font-semibold text-center">
        Total des moyens à mettre en place = 4
      </div>
      <div class="text-md font-semibold text-center">
        <br>
        <p>Non traités = 2</p>
        <p>En cours = 1</p>
        <p>Mis en place = 1</p>
      </div>
    </div>

    <!-- BEGIN Button to filter in preconisation list -->
    <div class="w-max-content w-max cursor-pointer relative mb-15">
      <div class="relative w-full flex">
        <span class="  text-teal-500 border rounded-full bg-teal-300 ml-10" style="padding:7px">
          <icon name="height"/>
        </span>
        <span class="text text-gray-900 text-base font-semibold ml-3 mt-1.5">Filtrer
          <div class="text-teal-600 inline-block ml-2 dropdown-menu"><icon name="chevron-down" /></div>
        </span>
      </div>
    </div>
    <!-- TODO : Dropdown for filter button -->

    <!-- END Button to filter in tab -->

    <div
class="text-base text-gray-600 font-medium
                 grid grid-cols-12 gap-x-4 gap-y-10"
    >
      <div class="col-start-2 xl:col-start-2 col-span- xl:col-span-2 w-2/12">Date</div>
      <div class="col-span- xl:col-span-4 ">Intitulé</div>
      <div class="col-span- xl:col-span-1 ">Comm.</div>
      <div class="hidden xl:col-span-2 ">Délai</div>
      <div class="hidden xl:col-span-2 ">Etat</div>
    </div>

    <div
v-for="(moyen, num) in form[tab_display]"
      :key="num"
      class="odd:bg-indigo-100 odd:bg-opacity-50"
    >
      <div
        class="h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer"
        :class="{'bg-indigo-200 border-l-2 border-indigo-600': itemDisplayed == num}"
        @click="displayItem(num)"
        :id="'item'+num"
      >
        <div class="col-span-1 text-pink-600 text-center">
          <icon
class="inline-block transform transition-transform ease-in-out duration-300"
            :class="{'rotate-90': itemDisplayed == num}"
            name="chevron-right"
          />
        </div>
        <div class=" w-2/12 text-sm text-gray-600 font-semibold ">
        {{ value= '20/06/2020'}}
      </div>
      <div class=" w-4/12 text-2sm font-bold italic">
        {{value= 'Prévention d\'éléments empiétants sur le chemin extérieur (au dessus du sol, près du sol, etc)'}}
      </div>
      <div class=" text-gray-600 w-1/12 mb-10 mt-8 ml-2">
        <icon name="message-circle"/>
      </div>
      <div class=" w-2/12 text-sm font-semibold">
        {{ value= '20/12/2020'}}
      </div>
      <div class=" text-sm text-indigo-600 bg-indigo-200 rounded-lg border-solid border">
        {{ value= 'En cours'}}
      </div>
      </div>
    <div
v-if="itemDisplayed == num"
    class="  w-full bg-white">

        <input-text-area
          name="moyens_mettre_place"
          libelle="Moyens à mettre en place"
          size="3"
          :value="a.moyens_mettre_place" @input="(newValue) => {a.moyens_mettre_place = newValue}"
          class="w-full  "
        />

        <date-picker
          name="delai_mise_place"
          :necessary-date="true"
          libelle="Délai de mise en place"
          class="w-1/2 "
          format="yyyy"
          min-view="year"
          :value="a.delai_mise_place" @input="(newValue) => {a.delai_mise_place = newValue}"
        />

        <input-select
          name="statut"
          libelle="Statut"
          size="3"
          :value="a.statut" @input="(newValue) => {a.statut = newValue}"
          :datas="[
                { value: 'Non traité' },
                { value: 'En cours' },
                { value: 'Mis en place'},
            ]"
          class="w-1/2  "
        />

    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import Icon from '../../../components/Icon';
import IconComment from'../../../components/Inputs/IconComment';


export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    IconComment,

  },

  name: 'Checklistdesmoyensmisenplace',

  data() {
    return {
      // Initial state of the form
      tab_display: 'accessibilite',
      itemDisplayed: -1,
      form: {
        accessibilite:{},
        postedetravail:{},
        autonomie:{},
      },
    };
  },
  mounted(){
    //each field saved is pasted in local form
    Object.assign(this.form, this.formContent);
    this.$parent.save_datas(false);
  },
  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),
    displayTab(nomPage){
      this.tab_display = nomPage;
    },
    displayItem(numItem){
      if(this.itemDisplayed == numItem){
        this.itemDisplayed = -1;
      }else{
        this.itemDisplayed = numItem;
        let pos = document.getElementById('item'+numItem);
        setTimeout(() => {pos.scrollIntoView({block:'start'});}, 300);
      }
    },
  },
  computed:{
    ...mapGetters({
      formContent: 'neopass/formContent'
    }),
    datas_form(){
      return this.form.filter(content => content.type_preco == this.tab_display);
    }
  },
  watch:{
    form: {
      handler(){
        this.SET_FORMCONTENT(this.form);
        this.calculate_progress();
      },
      deep: true
    }
  }
};
</script>
